import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/analytics';

/**
 * Mount once inside the router. Fires GA4 page_view on every SPA route change.
 * Excluded paths (admin, embed, dashboard sub-pages) are filtered inside trackPageView.
 */
export const useTrackPageView = (): void => {
  const location = useLocation();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    const path = location.pathname + location.search;
    if (lastPath.current === path) return;
    lastPath.current = path;
    // Defer to next frame so document.title reflects the new route.
    const id = window.requestAnimationFrame(() => trackPageView(path));
    return () => window.cancelAnimationFrame(id);
  }, [location.pathname, location.search]);
};
